const storefrontEvents = Object.freeze({
  coffeeClubViewed: 'bb_coffee_club_viewed',
  subscriptionRouteSelected: 'bb_subscription_route_selected',
  subscriptionSelectorStarted: 'bb_subscription_selector_started',
  subscriptionSelectorCompleted: 'bb_subscription_selector_completed',
  subscriptionAddedToCart: 'bb_subscription_added_to_cart',
  merchAddedToCart: 'bb_merch_added_to_cart',
});

const measurementContract = Object.freeze({
  storefront: storefrontEvents,
  shopifyNative: Object.freeze(['checkout_started', 'checkout_completed']),
  shopifyNativeMeaning: Object.freeze({
    checkout_started: 'bb_subscription_checkout_started',
    checkout_completed: 'bb_subscription_purchase_completed',
  }),
  subscriptionPlatform: Object.freeze([
    'bb_subscription_first_renewal',
    'bb_subscription_paused',
    'bb_subscription_pause_requested',
    'bb_subscription_cancelled',
    'bb_subscription_cancellation_requested',
    'bb_subscription_failed_payment',
    'bb_subscription_payment_recovered',
  ]),
  commercialMeasure: Object.freeze({
    name: 'margin_90_day_per_acquired_customer',
    requiredInputs: Object.freeze([
      'net_revenue_90_day',
      'coffee_cost_90_day',
      'fulfilment_cost_90_day',
      'shipping_subsidy_90_day',
      'payment_fees_90_day',
      'refund_cost_90_day',
      'acquisition_cost',
    ]),
  }),
});

const publishedPageEvents = new Set();

function cleanPayload(payload = {}) {
  return Object.fromEntries(
    Object.entries(payload).filter(([, value]) => value !== undefined && value !== null && value !== '')
  );
}

function publish(name, payload = {}) {
  const analyticsPublish = globalThis.Shopify?.analytics?.publish;
  if (typeof analyticsPublish !== 'function') return false;

  analyticsPublish(name, {
    schema_version: 1,
    ...cleanPayload(payload),
  });
  return true;
}

function publishOnce(key, name, payload = {}) {
  if (publishedPageEvents.has(key)) return false;
  if (!publish(name, payload)) return false;
  publishedPageEvents.add(key);
  return true;
}

function productContext(element) {
  const productForm = element.closest('product-form-component');
  return {
    product_id: productForm?.dataset.productId,
    product_url: productForm?.dataset.productUrl,
  };
}

function initialisePageTracking() {
  const coffeeClub = document.querySelector('.bb-club');
  if (coffeeClub) {
    publishOnce('coffee_club_viewed', storefrontEvents.coffeeClubViewed, {
      page_path: window.location.pathname,
    });
  }

  document.addEventListener('click', (event) => {
    const route = event.target?.closest?.('[data-bb-analytics-route]');
    if (!route) return;

    publish(storefrontEvents.subscriptionRouteSelected, {
      route: route.dataset.bbAnalyticsRoute,
      destination: route.getAttribute('href'),
      page_path: window.location.pathname,
      ...productContext(route),
    });
  });
}

globalThis.BobbysAnalytics = Object.freeze({
  eventContract: measurementContract,
  events: storefrontEvents,
  publish,
  publishOnce,
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initialisePageTracking, { once: true });
} else {
  initialisePageTracking();
}
